import { ReactNode, useEffect, useState } from "react";

import { appUpdatedContext } from "@context/Contexts";

type Props = {
  children: ReactNode;
};

const AppUpdatedProvider = ({ children }: Props) => {
  const [assetManifest, setAssetManifest] = useState<string | null>(null);
  const [assetManifestChanged, setAssetManifestChanged] = useState<boolean>(false);
  const [isUpdated, setIsUpdated] = useState(false);

  const toggleAppUpdated = (update: boolean) => {
    setIsUpdated(update);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (import.meta.env.NODE_ENV === "production") {
      if (!assetManifestChanged) {
        interval = setInterval(() => {
          const xhr = new XMLHttpRequest();
          xhr.open("GET", "asset-manifest.json", true);
          xhr.setRequestHeader("Cache-Control", "no-cache, no-store, max-age=0");
          xhr.setRequestHeader("Expires", "Tue, 01 Jan 1980 1:00:00 GMT");
          xhr.setRequestHeader("Pragma", "no-cache");
          xhr.onload = () => {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                const allText = xhr.responseText;
                const changed = assetManifest !== null && allText !== assetManifest;
                setAssetManifest(allText);
                setAssetManifestChanged(changed);
                if (changed) {
                  toggleAppUpdated(true);
                }
              }
            }
          };
          xhr.send(null);
        }, 120000);
      }
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [assetManifest, assetManifestChanged]);

  return (
    <appUpdatedContext.Provider value={{ appUpdatedState: isUpdated, toggle: toggleAppUpdated }}>
      {children}
    </appUpdatedContext.Provider>
  );
};

export default AppUpdatedProvider;
